import { apiTransformer } from 'utils';

export const competitionSecretaryToApiTransformer = values => {
    return {...apiTransformer(values, ['competition', 'secretary'])};
}
